import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — every route change scrolls the page to the top.
 * Preserves back/forward navigation position (browser handles that naturally).
 * Uses "auto" for instant jump (no scroll animation) so it doesn't fight
 * with our cinematic page transitions.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL includes a #hash, let the browser scroll to that element
    if (hash) return;
    // Instant jump so page transitions look clean
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
